import { render } from "./DistributionPage.vue?vue&type=template&id=566b50b7&scoped=true"
import script from "./DistributionPage.vue?vue&type=script&lang=js"
export * from "./DistributionPage.vue?vue&type=script&lang=js"

import "./DistributionPage.vue?vue&type=style&index=0&id=566b50b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566b50b7"]])

export default __exports__